module.exports = __webpack_public_path__ + "assets/img/right-top.ceb51726.png";